import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.menuItemData.url_blank ? _c("div", {
    staticClass: "menu-item"
  }, [_vm.menuItemData.is_vhtml ? _c("a", {
    attrs: {
      href: _vm.menuItemData.url_blank,
      title: _vm.menuItemData.title,
      target: "_blank"
    },
    domProps: {
      innerHTML: _vm._s(_vm.menuItemData.name)
    }
  }) : _c("a", {
    attrs: {
      href: _vm.menuItemData.url_blank,
      title: _vm.menuItemData.title,
      target: "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.menuItemData.name) + " ")])]) : _c("router-link", {
    attrs: {
      to: _vm.getRoute(_vm.menuItemData.route_name)
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var href = _ref.href,
          route = _ref.route,
          navigate = _ref.navigate,
          isActive = _ref.isActive,
          isExactActive = _ref.isExactActive;
        return [_c("div", {
          class: [isActive == true || _vm.isForceMenuOn ? "menu-active" : "", isExactActive == true ? "menu-exact-active" : "", "menu-item"]
        }, [_c("a", {
          attrs: {
            href: href
          },
          on: {
            click: navigate
          }
        }, [_vm._v(" " + _vm._s(_vm.menuItemData.name) + " ")])])];
      }
    }])
  });
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };